import React from 'react'
import Accordion from 'react-bootstrap/Accordion';
import Footer from '../component/Footer';

const Whychoose = () => {
    return (
        <>

            <div class="breadcrumb">
                <a href="/">Home</a> / Choose Us 
            </div>

            <div className='choose'>
                <br />
                <h1 className='text-center'>Why Choose Us?</h1>
                <div className='choose2'>

                    <div className='choose3'>

                        <Accordion defaultActiveKey="0">

                            <br /> <br />
                            <Accordion.Item eventKey="0">
                                <Accordion.Header >
                                    <p style={{ fontSize: '20px' }}>Specialized Urological Care</p></Accordion.Header>
                                <Accordion.Body>
                                    Expert care for a wide range of urological conditions, ensuring personalized treatment. From sexual health to complex urological issues, you're in capable hands.
                                </Accordion.Body>
                            </Accordion.Item>

                            <br /> <br />
                            <Accordion.Item eventKey="1">
                                <Accordion.Header>
                                    <p style={{ fontSize: '20px' }}>
                                        Urological Cancer Care

                                    </p> </Accordion.Header>
                                <Accordion.Body>
                                    Specialized treatment for urological cancers with advanced techniques for optimal outcomes. Expert care for kidney, bladder, and testicular cancers.
                                </Accordion.Body>
                            </Accordion.Item>

                        </Accordion>

                    </div>

                    <div className='choose3'>

                        <Accordion defaultActiveKey="0">

                            <br /> <br />
                            <Accordion.Item eventKey="0">
                                <Accordion.Header >
                                    <p style={{ fontSize: '20px' }}>Sexual Health Solutions</p></Accordion.Header>
                                <Accordion.Body>
                                    Comprehensive treatments for sexual health concerns to enhance quality of life. Expertise in addressing erectile dysfunction and other related issues.
                                </Accordion.Body>
                            </Accordion.Item>

                            <br /> <br />
                            <Accordion.Item eventKey="1">
                                <Accordion.Header>
                                    <p style={{ fontSize: '20px' }}>
                                        Minimally Invasive Techniques

                                    </p> </Accordion.Header>
                                <Accordion.Body>
                                    Advanced robotic-assisted and laparoscopic procedures for effective, less invasive surgeries. Promotes quicker recovery and successful outcomes.
                                </Accordion.Body>
                            </Accordion.Item>

                        </Accordion>



                    </div>

                </div>

            </div>



            <Footer />
        </>
    )
}

export default Whychoose